import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { MarketPage } from "@/features/economy/components/market-page";
import { useI18n } from "@/providers/i18n-provider";

// Tab «Mercado» — economía de Bellotas (packs, vídeo recompensado, recompensa
// diaria, canje de marcos/stickers). Wave 1 agente F (`features/economy/`).
function MarketRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Mercado de Bellotas`)}
      description={t(
        msg`Inicia sesión para ganar y gastar Bellotas en marcos y stickers de coleccionista.`,
      )}
    >
      <MarketPage />
    </AuthPlaceholder>
  );
}

export const marketRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/market",
  component: MarketRoutePage,
});
